import React from 'react'
import { adminMenuItems } from '../../constants/adminMenuItems'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

export default function AdminSidebar({ selected }) {
  const navigate = useNavigate()
  const { isAuthenticated, logout } = useAuth()

  const onClickMenuItem = (link) => {
    navigate(link)
  }

  const handleLogout = async () => {
    await logout()
  }

  return (
    <aside className="sticky top-0 h-screen w-56 bg-header-bg border-r border-gray-200 shadow-header flex flex-col">
      <div className="h-20 flex items-center justify-center border-b border-gray-300 px-4">
        <img src="/eastsoko-logo.png" alt="Sokooni Logo" className="h-9 w-auto" />
      </div>
      <nav className="flex-1 mt-12 flex flex-col gap-2.5 px-3">
        {adminMenuItems.map((item) => (
          <button
            key={item.key}
            onClick={() => onClickMenuItem(item.link)}
            className={`flex items-center gap-4 w-full h-9 px-2.5 py-1.5 rounded font-inter text-lg font-normal transition-colors duration-150
              ${
                selected === item.key
                  ? 'bg-secondary-700 text-white shadow-md'
                  : 'text-gray-800 hover:bg-secondary-100 hover:text-secondary-700'
              }
            `}
          >
            <span className="w-6 h-6 flex items-center justify-center">{item.icon}</span>
            <span>{item.label}</span>
          </button>
        ))}
      </nav>

      {isAuthenticated() && (
        <button
          className="mt-auto w-full py-3 font-medium transition-all duration-300 text-error-900 bg-red-50 hover:bg-red-100 hover:shadow-lg"
          onClick={handleLogout}
        >
          Logout
        </button>
      )}
    </aside>
  )
}
